/**
 * iwoNoticeServiceModule 系统公告服务
 * author: Qian.qianchen 2019-06-28
 */
'use strict';
angular
    .module('iwoNoticeServiceModule', [
        'iwoUploadFilesModule',
        'iwouserAndDeptTransferModule',
        'noticeGroupModule',
        'createNoticeGroupModule',
        'noticePreviewModule',
        'iwoNoticeNewCreateModule',
    ])
    .factory('iwoNoticeService', [
        '$modal',
        '$q',
        'trsHttpService',
        'messagePublishService',
        '$sessionStorage',
        'globleParamsSet',
        'modalDialog',
        '$timeout',
        function($modal, $q, trsHttpService, messagePublishService, $sessionStorage, globleParamsSet, modalDialog, $timeout) {
            return {

                /**
                 * [uploadFiles description]上传文件
                 * @return {[type]} [description]
                 */
                uploadFiles: function() {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/iWo/notice/services/uploadFiles/uploadFiles_tpl.html',
                        windowClass: 'upload_files_container',
                        backdrop: false,
                        controller: 'iwoUploadFilesCtrl',
                        resolve: {},
                    });
                    // 关闭弹窗
                    modalInstance.result.then(
                        function(result) {
                            defer.resolve(result);
                        },
                        function() {
                            defer.reject('cancel');
                        }
                    );
                    return defer.promise;
                },

                /**
                 * [userAndDeptTransfer 选择发布范围]
                 *
                 * @param {[type]} params   [params description]
                 * @param {[type]} callback   [callback description]
                 * @param {[type]} selectedUser   [selectedUser description]
                 * @param {[type]} selectedType   [selectedType description]
                 * @param {[type]} tabArr   [tabArr description]
                 * @param {[type]} title   [title description]
                 *
                 * @return {[type]}   [return description]
                 */
                userAndDeptTransfer: function(params, callback, selectedUser, selectedType, tabArr, title) {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/iWo/notice/services/userAndDeptTransfer/userAndDeptTransfer_tpl.html',
                        windowClass: 'user_and_dept_transfer_container',
                        backdrop: false,
                        controller: 'iwouserAndDeptTransferCtrl',
                        resolve: {
                            params: function() {
                                return params;
                            },
                            selectedUser: function() {
                                return selectedUser;
                            },
                            selectedType: function() {
                                return selectedType;
                            },
                            tabArr: function() {
                                return tabArr;
                            },
                            title: function() {
                                return title || '选择发布范围';
                            }

                        },
                    });
                    // 关闭弹窗
                    modalInstance.result.then(
                        function(result) {
                            callback && callback(result);
                            defer.resolve(result);
                        },
                        function() {
                            defer.reject('cancel');
                        }
                    );
                    return defer.promise;
                },

                // 分组管理弹窗
                groupManage: function() {
                    $modal.open({
                        templateUrl: './editingCenter/iWo/notice/services/groupManage/group_manage_tpl.html',
                        windowClass: 'notice-groupManage-window',
                        backdrop: false,
                        controller: 'noticeGroupManageCtrl',
                        resolve: {
                            Params: function() {
                                return {};
                            },
                        },
                    });
                },

                /**
                 * [createGroup 新建分组弹窗]
                 *
                 * @param   {[type]}  params        [params 编辑分组时传入分组信息]
                 * @return  {[type]}                [return description]
                 */
                createGroup: function(params) {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/iWo/notice/services/createNoticeGroup/createNoticeGroup_tpl.html',
                        windowClass: 'create_group_container',
                        backdrop: false,
                        controller: 'createNoticeGroupCtrl',
                        resolve: {
                            params: function() {
                                return params;
                            },
                        },
                    });
                    // 关闭弹窗
                    modalInstance.result.then(
                        function(result) {
                            defer.resolve(result);
                        },
                        function() {
                            defer.reject('cancel');
                        }
                    );
                    return defer.promise;
                },

                // 获取通知公告权限
                getNoticeRights: function() {
                    let defer = $q.defer();
                    const params = {
                        serviceid: 'mlf_metadataright',
                        methodname: 'queryOperKeysOfNormalModal',
                        Classify: 'iwo.notice',
                        Modalname: 'I我',
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'GET').then((data) => {
                        defer.resolve(data);
                    });
                    return defer.promise;
                },

                // 添加分组
                addGroup: function(params) {
                    let defer = $q.defer();
                    const commonParams = {
                        serviceid: 'mlf_releasesource',
                        methodname: 'saveLabelOrganization',
                    };
                    params = angular.extend(params, commonParams);
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'POST').then(
                        (data) => {
                            defer.resolve(data);
                        },
                        (data) => {
                            defer.reject(data);
                        }
                    );
                    return defer.promise;
                },

                // 删除分组
                deleteGroup: function(params) {
                    let defer = $q.defer();
                    const commonParams = {
                        serviceid: 'mlf_releasesource',
                        methodname: 'deleteLabelOrganization',
                    };
                    params = angular.extend(params, commonParams);
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'POST').then((data) => {
                        defer.resolve(data);
                    });
                    return defer.promise;
                },

                // 编辑分组保存
                editGroup: function(params) {
                    let defer = $q.defer();
                    const commonParams = {
                        serviceid: 'mlf_releasesource',
                        methodname: 'editLabelOrganization',
                    };
                    params = angular.extend(params, commonParams);
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'POST').then((data) => {
                        defer.resolve(data);
                    });
                    return defer.promise;
                },

                // 获取分组列表
                getGroups: function(params) {
                    let defer = $q.defer();
                    const commonParams = {
                        serviceid: 'mlf_releasesource',
                        methodname: 'queryOrganizationsByKeyWords',
                    };
                    params = angular.extend(params, commonParams);
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'GET').then((data) => {
                        defer.resolve(data);
                    });
                    return defer.promise;
                },

                // 获取用户自己收到的通知
                getReciveNoticeList: function(params) {
                    let defer = $q.defer();
                    const commonParams = {
                        serviceid: 'notice',
                        method: 'receivedNoticeList',
                    };
                    params = angular.extend(params, commonParams);
                    trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'GET').then((data) => {
                        defer.resolve(data);
                    });
                    return defer.promise;
                },

                // 获取所有通知公告
                getNoticeList: function(params) {
                    let defer = $q.defer();
                    const commonParams = {
                        serviceid: 'notice',
                        method: 'noticeList',
                    };
                    params = angular.extend(params, commonParams);
                    trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'GET').then((data) => {
                        defer.resolve(data);
                    });
                    return defer.promise;
                },

                /**
                 * [openPreview description]打开详情页
                 *
                 * @param   {[type]}  params  [params description]
                 * @param   {[type]}  ismanage  [params description] 判断是公告管理还是前台页面
                 * @return  {[type]}          [return description]
                 */
                openPreview: function(params, ismanage) {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/iWo/notice/services/noticePreview/noticePreview.html',
                        windowClass: 'noticePreview',
                        backdrop: false,
                        controller: 'noticePreviewCtrl',
                        resolve: {
                            params: function() {
                                return params;
                            },
                            ismanage: function() {
                                return ismanage;
                            },
                        },
                    });
                    // 关闭弹窗
                    modalInstance.result.then(
                        function(result) {
                            defer.resolve(result);
                        },
                        function() {
                            defer.reject('cancel');
                        }
                    );
                    return defer.promise;
                },

                /**
                 * [openPreview description]新建编辑公告
                 *
                 * @param   {[type]}  params  [params description]
                 * @param   {[type]}  hasPublish  [params description] 是否有发布权限
                 *
                 * @return  {[type]}          [return description]
                 */
                openNewCreate: function(params, hasPublish) {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/iWo/notice/services/newNotice/newNotice.html',
                        windowClass: 'iwoNoticeNewCreateCtrl',
                        backdrop: false,
                        controller: 'iwoNoticeNewCreateCtrl',
                        resolve: {
                            params: function() {
                                return params;
                            },
                            hasPublish: function() {
                                return hasPublish;
                            },
                        },
                    });
                    // 关闭弹窗
                    modalInstance.result.then(
                        function(result) {
                            defer.resolve(result);
                        },
                        function() {
                            defer.reject('cancel');
                        }
                    );
                    return defer.promise;
                },

                getUnReadNoticeCount: function() {
                    let defer = $q.defer();
                    const commonParams = {
                        serviceid: 'notice',
                        method: 'numberOfUnreadMessages',
                        userid: this.getUserId(),
                    };
                    const params = angular.extend({}, commonParams);
                    trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'GET').then((data) => {
                        if (data.issuccess === 'true') {
                            messagePublishService.publish('unReadNoticeCountUpdate', data.data.num);
                        }
                        defer.resolve(data);
                    });
                    return defer.promise;
                },

                // 编辑页数据
                initEditData: function(myparams) {
                    let defer = $q.defer();
                    this.getCookie().then((token) => {
                        const commonParams = {
                            serviceid: 'notice',
                            method: 'noticeDetial',
                            token: token,
                        };
                        const params = angular.extend(myparams, commonParams);
                        trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'GET').then((data) => {
                            defer.resolve(data);
                        });
                    });

                    return defer.promise;
                },

                // 获取公告类型
                getNoticeTypeList: function() {
                    let defer = $q.defer();
                    const commonParams = {
                        serviceid: 'noticetype',
                        method: 'noticetypeForDetail',
                    };
                    trsHttpService.httpServer(trsHttpService.getMessageUrl(), commonParams, 'GET').then((data) => {
                        defer.resolve(data);
                    });
                    return defer.promise;
                },

                // 公告的保存更新
                save: function(myparams) {
                    let defer = $q.defer();
                    trsHttpService.httpServer(trsHttpService.getMessageUrl(), myparams, 'POST').then((data) => {
                        defer.resolve(data);
                    });
                    return defer.promise;
                },

                // 公告的发布
                publish: function(myparams) {
                    let defer = $q.defer();
                    this.getCookie().then((token) => {
                        const commonParams = {
                            serviceid: 'notice',
                            method: 'publishNotice',
                            token: token,
                        };
                        const params = angular.extend(myparams, commonParams);
                        trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'POST').then((data) => {
                            if (data.issuccess) {
                                this.getUnReadNoticeCount();
                            }
                            defer.resolve(data);
                        });
                    });
                    return defer.promise;
                },

                // 获取需要的cookie
                getCookie: function() {
                    let defer = $q.defer();
                    if ($sessionStorage.cookie.get('userToken')) {
                        defer.resolve($sessionStorage.cookie.get('userToken').token);
                    } else {
                        globleParamsSet.getTokenService($sessionStorage.get('curUserInfo').TENANTID).then((data) => {
                            defer.resolve(data.token);
                        });
                    }
                    return defer.promise;
                },

                getUserId: function() {
                    return $sessionStorage.get('curUserInfo').ID;
                },

                /**
                 * [getSearchValue description]搜索时的下拉框
                 *
                 * @param   {[type]}  viewValue  [viewValue description]
                 * @param   {[type]}  type       [type description]有三种类型
                 *
                 * @return  {[type]}             [return description]
                 */
                getSearchValue: function(viewValue, type) {
                    var promise;
                    if (!viewValue) {
                        return;
                    }
                    if (promise) {
                        $timeout.cancel(promise);
                        promise = null;
                    }
                    promise = $timeout(function() {
                        var searchParams = {};
                        switch (type) {
                            case 2:
                                searchParams = {
                                    serviceid: 'mlf_releasesource',
                                    methodname: 'queryOrganizationsByKeyWords',
                                    pageSize: 100,
                                    keyWords: angular.isObject(viewValue) ? viewValue.LABELNAME : viewValue,
                                };
                                break;
                            case 1:
                                searchParams = {
                                    serviceid: 'mlf_extuser',
                                    methodname: 'searchGroup',
                                    Name: angular.isObject(viewValue) ? viewValue.GNAME : viewValue,
                                };
                                break;
                            case 0:
                                searchParams = {
                                    serviceid: 'mlf_extuser',
                                    methodname: 'searchUserOrDept',
                                    Name: angular.isObject(viewValue) ? viewValue.USERNAME : viewValue,
                                };
                                break;
                        }
                        // var searchParams = {
                        //     serviceid: 'mlf_personalsource',
                        //     methodname: 'getRecentUsageSources',
                        //     SrcName: angular.isObject(viewValue) ? viewValue.SRCNAME : viewValue,
                        // };
                        // var searchParams = {
                        //     serviceid: 'mlf_releasesource',
                        //     methodname: 'queryOrganizationsByKeyWords',
                        //     pageSize: 100,
                        //     keyWords: angular.isObject(viewValue) ? viewValue.LABELNAME : viewValue,
                        // };
                        // if (params) {
                        //     searchParams = params;
                        // }
                        return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), searchParams, 'post').then(function(data) {
                            return data.DATA ? data.DATA : data;
                        });
                    }, 100);
                    return promise;
                },
            };
        },
    ]);
